import type { CreateCustomerNoteRequestPayload, CreateCustomerNoteResponse } from '@vy/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../../../../../services/api';
import { queryKeys } from '../../../../../../services/query-key/query-keys';

type CreateCustomerNoteVariables = CreateCustomerNoteRequestPayload & { customerId: string };

export function useCreateCustomerNote(
  options?: UseMutationOptions<CreateCustomerNoteResponse, unknown, CreateCustomerNoteVariables>,
) {
  const queryClient = useQueryClient();

  return useMutation(
    ({ customerId, ...createCustomerNoteRequest }) => {
      const api = getPrivateApi();

      return api.createCustomerNote({
        customerId,
        createCustomerNoteRequest,
      });
    },
    {
      ...options,
      onSuccess: async (data, variables, context) => {
        await queryClient.invalidateQueries(queryKeys.customerNotes(variables.customerId));

        await options?.onSuccess?.(data, variables, context);
      },
    },
  );
}
